import React, { useEffect, useState } from 'react';
import { RangeCriteriaForm } from './RuleForm.RangeCriteriaForm';

export interface MeasurementsFormState {
  width: {
    from: string;
    to: string;
  };
  height: {
    from: string;
    to: string;
  };
  length: {
    from: string;
    to: string;
  };
}

interface Props {
  value?: MeasurementsFormState;
  onChange: (e: MeasurementsFormState) => void;
}

const MeasurementCriteriaForm = ({ onChange, value }: Props) => {
  const [formState, setFormState] = useState(
    value || {
      width: {
        from: '',
        to: '',
      },
      height: {
        from: '',
        to: '',
      },
      length: {
        from: '',
        to: '',
      },
    },
  );

  useEffect(() => {
    onChange(formState);
  }, [formState]);

  return (
    <div className="w-full">
      <div className="flex w-full">
        <div className="w-[200px] mr-6">
          <RangeCriteriaForm
            addonRight={<div style={{ color: '#94A3B8' }}>m</div>}
            value={formState.height}
            placeholder={['Alto mín.', 'Alto máx.']}
            inputPlaceholders={['0.1', '0.2']}
            onChange={(v) => setFormState({ ...formState, height: v })}
          />
        </div>
        <div className="w-[200px]  mr-6">
          <RangeCriteriaForm
            addonRight={<div style={{ color: '#94A3B8' }}>m</div>}
            value={formState.width}
            placeholder={['Ancho mín.', 'Ancho máx.']}
            inputPlaceholders={['0.1', '0.2']}
            onChange={(v) => setFormState({ ...formState, width: v })}
          />
        </div>
        <div className="w-[200px] ">
          <RangeCriteriaForm
            addonRight={<div style={{ color: '#94A3B8' }}>m</div>}
            value={formState.length}
            placeholder={['Largo mín.', 'Largo máx.']}
            inputPlaceholders={['0.1', '0.2']}
            onChange={(v) => setFormState({ ...formState, length: v })}
          />
        </div>
      </div>
    </div>
  );
};

export default MeasurementCriteriaForm;
